module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/gaming-dccba36f362260f30be10e93daf4d99d.png";